import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=2b6b1308&scoped=true&"
import script from "./GlobalSettings.vue?vue&type=script&lang=js&"
export * from "./GlobalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b1308",
  null
  
)

export default component.exports